'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _actions3 = require('../../../../customer/actions');

var _actions4 = _interopRequireDefault(_actions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App');

function mapStateToProps(state) {
    return {
        pending: state.cart.sendingOrder,
        termsUrl: state.cart.termsUrl,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon),
        hasShoppingConditionsConsent: state.cart.hasShoppingConditionsConsent,
        hasCustomerReviewConsent: state.cart.hasCustomerReviewConsent,
        consentError: (state.customer.contactErrors.clientErrors.primary || {}).hasShoppingConditionsConsent,
        noteError: state.cart.noteError
    };
}

var mapDispatchToProps = {
    sendOrder: _actions2.default.sendOrder,
    changeConsentValue: _actions2.default.changeConsentValue,
    validate: _actions4.default.validate
};

var OrderConfirmation = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(OrderConfirmation, _React$PureComponent);

    function OrderConfirmation() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderConfirmation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderConfirmation.__proto__ || (0, _getPrototypeOf2.default)(OrderConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.submitOrder = function (e) {
            if (_this.props.processing || _this.props.noteError || !_this.props.canContinue()) return;
            e.preventDefault();
            _this.props.sendOrder();
        }, _this.conditionsConsentChange = function (event) {
            _this.props.changeConsentValue(event.target.checked, false);
            _this.props.validate();
        }, _this.reviewConsentChange = function (event) {
            _this.props.changeConsentValue(event.target.checked, true);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(OrderConfirmation, [{
        key: 'getConsentErrorMessageElement',
        value: function getConsentErrorMessageElement(consentError) {
            return consentError ? _react2.default.createElement(
                'div',
                { className: 'be-aware-info' },
                consentError
            ) : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                pending = _props.pending,
                processing = _props.processing,
                termsUrl = _props.termsUrl,
                canContinue = _props.canContinue,
                consentError = _props.consentError,
                noteError = _props.noteError;

            var btnClass = 'btn btn--xl btn--green';
            if (pending) {
                btnClass += ' btn--pending';
            }
            if (!canContinue() || processing || noteError) {
                btnClass += ' btn--inactive';
            }
            var consentClass = 'above__submit consent-pane ' + (consentError ? 'warning' : '');

            return _react2.default.createElement(
                'div',
                { className: 'cart__submit' },
                this.getConsentErrorMessageElement(consentError),
                _react2.default.createElement(
                    'div',
                    { className: consentClass },
                    _react2.default.createElement('input', { type: 'checkbox', id: 'shoppingConditionsConsent', name: 'shoppingConditionsConsent',
                        onChange: function onChange(event) {
                            return _this2.conditionsConsentChange(event);
                        } }),
                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: Resx.Messages.CartConfirmationMessage.replace('{0}', termsUrl) } })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'above__submit consent-pane' },
                    _react2.default.createElement('input', { type: 'checkbox', id: 'customerReviewConsent', name: 'customerReviewConsent',
                        onChange: function onChange(event) {
                            return _this2.reviewConsentChange(event);
                        } }),
                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: Resx.Messages.Cart3StepPersonalDataForwardingConsent } })
                ),
                _react2.default.createElement(
                    'button',
                    { className: btnClass, onClick: this.submitOrder },
                    Resx.App.BindOrder
                )
            );
        }
    }]);
    return OrderConfirmation;
}(_react2.default.PureComponent), _class2.propTypes = {
    pending: _propTypes2.default.bool,
    sendOrder: _propTypes2.default.func,
    changeConsentValue: _propTypes2.default.func,
    validate: _propTypes2.default.func,
    processing: _propTypes2.default.bool,
    hasShoppingConditionsConsent: _propTypes2.default.bool,
    hasCustomerReviewConsent: _propTypes2.default.bool,
    canContinue: _propTypes2.default.func,
    termsUrl: _propTypes2.default.string,
    consentError: _propTypes2.default.string,
    noteError: _propTypes2.default.string
}, _temp2)) || _class);
exports.default = OrderConfirmation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/OrderConfirmation.js
// module id = 754
// module chunks = 0